import React from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import { setGable14UnavailableModalOpen, setloftUnavailableModalOpenModalOpen } from '../../store/ui/uiSlice'

import Card from '../Card/Card'

import * as Styled from '../styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

// TODO--låg-prio slå ihop komponent med SizePanel!
const ASSEMBLY_ID = 'assembly'

const RoofKindPanel: React.FC = () => {
  const configurator = useConfiguratorContext()
  const dispatch = useAppDispatch()

  const {
    meta: { roofAngle },
    props: { roofKind, loftLeft, loftRight },
  } = useAppSelector((state) => state.configResult) as any
  const { assetBaseUrl, content } = useAppSelector((state) => state.init)

  return (
      <Styled.Panel>
        <Styled.Grid $responsive>
          {roofKind.options.map((option: any) => (
            <Card
              key={option.value}
              type="lightweight"
              isSelected={option.value === roofKind.value}
              onClick={() => {
                if (option.value === 'gable-25' && (loftLeft.value || loftRight.value)) {
                  dispatch(setloftUnavailableModalOpenModalOpen(true))
                } else if (option.value === 'gable-14-extended' && !option.available) {
                  dispatch(setGable14UnavailableModalOpen(true))
                } else {
                  configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
                    roofKind: option.value,
                  })
                }
              }}
              testId={`roof-kind-option-${option.value}`}
              dangerouslySetInfo={content?.props?.roofKind?.options?.[option.value]?.description}
              mediaAlt={content?.props?.roofKind?.options?.[option.value]?.title}
              mediaImage={`${assetBaseUrl}${content?.props?.roofKind?.options?.[option.value]?.image}`}
              title={content?.props?.roofKind?.options?.[option.value]?.title}
              titleLong={content?.props?.roofKind?.options?.[option.value]?.description}
            />
          ))}
        </Styled.Grid>
        <span>
          {content?.meta?.roofAngle?.title}: <strong>{roofAngle}°</strong>
        </span>
      </Styled.Panel>
  )
}

export default RoofKindPanel
